import type { CSSProperties } from 'react';

/** Explicit track/thumb styling also works in Telegram's embedded WebKit. */
export function RangeControl({ label, value, min, max, step, valueText, onChange }: {
  label: string; value: number; min: number; max: number; step: number;
  valueText?: string; onChange: (value: number) => void;
}) {
  const progress = Math.max(0, Math.min(100, (value - min) / (max - min) * 100));
  return <input className="range-control" type="range" aria-label={label}
    aria-valuetext={valueText} min={min} max={max} step={step} value={value}
    style={{ '--range-progress': `${progress}%` } as CSSProperties}
    onChange={event => onChange(Number(event.target.value))} />;
}
